import { registerLandingPageServiceWorker } from '..';

export function startServiceWorkerRuntime() {
  return registerLandingPageServiceWorker();
}
